module.exports = __webpack_public_path__ + "img/46.1143200c.jpg";